import axios from 'axios';
import { Message } from '@arco-design/web-vue';
import { getToken } from '@/utils/auth';

// 定义返回数据类型
declare module "axios" {
  interface AxiosResponse {
    total: number;
    current_page: number;
    last_page: number
  }
  export function create(config?: AxiosRequestConfig): AxiosInstance;
}

const ApiUrl = process.env.VUE_APP_ApiUrl;

// 创建axios实例
const http = axios.create({
  timeout: 15000,
  baseURL: ApiUrl,
});

// request拦截器
http.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// respone拦截器
http.interceptors.response.use(
  (res) => {
    if (res.status == 200) {
      if (res.data.msg) {
        Message.error({
          content: res.data.msg || "Error",
          duration: 5 * 1000
        })
        if (res.data.code == 401 || res.data.code == 403) {
          window.location.replace("/");
        }
        return Promise.reject(res.data.msg || "Error");
      }
      return res.data
    } else {
      Message.error({
        content: res.statusText || 'Error',
        duration: 5 * 1000,
      });
      return Promise.reject(res.statusText || "Error");
    }
  },
  (error) => {
    Message.error({
      content: error.message || '加载失败，请联系管理员',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default http;
